const CREATIVE_CREDITS_SAVE_ERRORS = {
    saveCreativeCreditsMutationErrorMessage:
        'The save creative credits mutation failed with an error in the response!',
    saveCreativeCreditsServerErrorMessage: 'The save creative credits operation failed with a server error!'
} as const;

export class SaveCreativeCreditsMutationError extends Error {
    constructor(message?: string) {
        super(message || CREATIVE_CREDITS_SAVE_ERRORS.saveCreativeCreditsMutationErrorMessage);
        this.name = 'SaveCreativeCreditsMutationError';
    }
}

export class SaveCreativeCreditsServerError extends Error {
    constructor(message?: string) {
        super(message || CREATIVE_CREDITS_SAVE_ERRORS.saveCreativeCreditsServerErrorMessage);
        this.name = 'SaveCreativeCreditsServerError';
    }
}
